import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from 'src/app/service/notification.service';
import { FormBuilder } from '@angular/forms';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { MatTableDataSource } from '@angular/material/table';
import { AssignmentQueue } from 'src/app//model/assignment-portal/assignment-portal';
import { AssignmentQueuePageRequest } from 'src/app/model/assignment-portal/assignment-portal-page-request';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';
import { AssignmentPortalService } from 'src/app/service/assignment-portal.service';
import { MatDialog } from '@angular/material/dialog';
import { ManageCoderComponent } from './manage-coder/manage-coder.component';

@Component({
  selector: 'app-assign-coder',
  templateUrl: './assign-coder.component.html',
  styleUrls: ['./assign-coder.component.scss']
})
export class AssignCoderComponent implements OnInit {

  assignmentQueueForm: FormGroup;
  assignmentQueue: AssignmentQueue = new AssignmentQueue();
  assignmentQueueList: AssignmentQueue[];
  show: boolean = false;
  scheduledDate: string;
  isManageCoderDisabled: boolean = false;
  coderName:string;
  nameFilter = new FormControl();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<AssignmentQueue>;
  isRadionButtonClicked: boolean = false;
  localstoreValueUserName: string = "";
  localstoreCoderName: string = "";
  localStoreAssignmentQueueName: string = "";
  searchKey: string = "";
  localStoreAssignmentQueueId: string = "";
  localStoreProviderId: string = "";
  loginUserId: string = "";
  diagnosisCount: number;

  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  length: number;
  pageSizeOptions: number[] = [15, 30, 45];
  assignmentQueuePageRequest: AssignmentQueuePageRequest = new AssignmentQueuePageRequest();
  displayedColumns = ['radioButton', 'coderName', 'userId', 'email', 'phoneNumber', 'coderLevel', 'qaNeeded', 'clientNames', 'projectNames'];


  constructor(
    private _assignmentPortalService: AssignmentPortalService,
    private _notificationService: NotificationService,
    private _formBuilder: FormBuilder,
    private _localStorage: LocalStorageService,
    private datePipe: DatePipe,
    public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this._localStorage.store('PageEvent', undefined);
    this.loginUserId = "";

    this.assignmentQueueForm = this._formBuilder.group({
      scheduleDate: new FormControl('', Validators.required),

    });

    this.isManageCoderDisabled = true;
    this.getAssignmentQueueListData();
    
  }

  getAssignmentQueueListData(event?: PageEvent, clearPagination?: boolean) {
    if(clearPagination){
      this._localStorage.store('PageEvent', undefined);
    }
    if (event != undefined) {
      this._localStorage.store('PageEvent', event);
       this.assignmentQueuePageRequest.pageNum = event.pageIndex;
       this.assignmentQueuePageRequest.pageSize = event.pageSize;
     }else if (event === undefined || event === null) {
       this.assignmentQueuePageRequest.pageNum = 0;
       this.assignmentQueuePageRequest.pageSize = 15;
     }
     this.assignmentQueuePageRequest.sortBy = "coderName";
     this.assignmentQueuePageRequest.sortDir = "ASC";
     if(this.searchKey!= undefined && this.searchKey != null){
       this.assignmentQueuePageRequest.searchValue = this.searchKey.toLowerCase();
     }else{
       this.assignmentQueuePageRequest.searchValue = '';
     }
     this._assignmentPortalService.getCoderList(this.assignmentQueuePageRequest)
       .subscribe(result => {
         if (!result) {
           return;
         }
         console.log(result);
         this.assignmentQueue = result.coders;
         this.dataSource = new MatTableDataSource(result.coders);
         this.dataSource.sort = this.sort;
   
         if (event != undefined) {
           this.pageIndex = event.pageIndex;
           this.pageSize = event.pageSize;
           this.length = result.totalCount;
         }
         if (event === undefined || event === null) {
           this.pageIndex = 0;
           this.pageSize = 15;
           this.length = result.totalCount;
         }
         //this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
         //  this.dataSource.data = this.filterOptions(nameFilterValue);
         //});
       }, error => console.log(error));
       return event;
   }

   filterOptions(nameValue: string): AssignmentQueue[] {
    if (!nameValue) {
      return this.assignmentQueueList;
    }
    const filtered = this.assignmentQueueList.filter((element) => {
      return (nameValue ? element.coderName.toLowerCase().includes
        (nameValue.toLowerCase()) : false)
    });
    return filtered;
  }

  radiobuttonClick(event, assignmentQueue: AssignmentQueue): void {
    //if(!coder.disableRow){
    this.isRadionButtonClicked = true;
    this.assignmentQueue = assignmentQueue;
    this.show = true;
    this.isManageCoderDisabled = false;
    //this._localStorage.store("providerId", this.loginUserId);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  reset() {
    this.isRadionButtonClicked = false;
    this.isManageCoderDisabled = true;
    this.assignmentQueue = null;
    this.getAssignmentQueueListData();
  }
  onSearchClear() {
    this.diagnosisCount = undefined;
    this.searchKey = "";
    //this.dataSource = undefined;
    this.getAssignmentQueueListData();
  }

  openManageCoder(): void {
    const dialogRef = this.dialog.open( ManageCoderComponent, {
      panelClass: 'assign-sch-model',
      data: this.assignmentQueue,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("result " + result);
      this.getAssignmentQueueListData(this._localStorage.retrieve('PageEvent'));
    });
  }

}
